export default {
    initOtherList() {
        return [
            {
                id: "other1",
                imgUrl: "https://www.caefi.org.cn/img/img_211x111_01.png",
                to: "https://www.chinafair.org.cn/",
            },
            {
                id: "other2",
                imgUrl: "https://www.caefi.org.cn/img/img_211x111_02.png",
                to: "http://www.expocentralchina.org.cn/",
            },
            {
                id: "other3",
                imgUrl: "https://www.caefi.org.cn/img/img_211x111_03.png",
                to: "https://www.ciie.org/zbh/index.html",
            },
            {
                id: "other4",
                imgUrl: "https://www.caefi.org.cn/img/img_211x111_04.png",
                to: "https://www.ciftis.org/",
            },
            {
                id: "other5",
                imgUrl: "https://www.caefi.org.cn/img/img_211x111_05.png",
                to: "https://www.cantonfair.org.cn/",
            }
        ]
    },
    initArticleList(num) {
        // let contentList = [
        //     {
        //         index: "ct1",
        //         content: "        2023年7月20日晚，成渝涉外商会联盟仲夏联谊酒会暨第八届商务速配活动在重庆市渝中区招商中心成功举行。在重庆市商务委、渝中区商务委、渝中区招商局支持下，重庆市外商投资企业协会、中国欧盟商会等联合英、意、瑞、法、韩、新、老、澳、墨、美等国商协会，以及市侨联、华商会、侨青会、澳门商会、咖啡商会、跨境电商等22家涉外机构共同主办，来自各行各业近200位商务人士积极响应，交流行业信息、展示合作项目、挖掘合作意向。\n" +
        //             "\n" +
        //             "        成渝涉外商会联盟在重庆市商务委、渝中区政府指导下，由重庆市外商投资企业协会等成渝地区20余家外国商协会、机构发起，于2021年10月在重庆市渝中区解放碑环球金融中心挂牌成立。商务速配活动由中国欧盟商会西南分会和重庆市外商投资企业协会发起并共同主办，以2分钟速配交流方式，为商务人士提供高效务实拓展人脉的平台。嘉士伯重啤为活动提供赞助。",
        //         imgUrl: "https://www.caefi.org.cn/",
        //         type: "text"
        //     },
        //     {
        //         index: "ct2",
        //         content: "",
        //         imgUrl: "http://resources.caefi.org.cn/uploadfile/img/202308/02/20230802140057341.jpg",
        //         type: "img"
        //     },
        //     {
        //         index: "ct3",
        //         content: "",
        //         imgUrl: "http://resources.caefi.org.cn/uploadfile/img/202308/02/20230802140114797.jpg",
        //         type: "img"
        //     },
        //     {
        //         index: "ct4",
        //         content: "",
        //         imgUrl: "http://resources.caefi.org.cn/uploadfile/img/202308/02/20230802140133874.jpg",
        //         type: "img"
        //     }
        // ];
        let result = [
            {
                id: "1",
                title: "常务副会长张召堂陪同韩国成东集团董事长郑洪俊先生考察青岛、长三角及珠三角项目对接",
                content: "4月20日至7月25日，中国外商投资企业协会开发区工作委员会常务副会长张召堂陪同韩国成东集团董事长郑洪俊先生一行，对中国山东半岛、长三角和珠三角地区进行了一系列项目考察与对接活动。此次考察旨在探索合作机会，推动双方在科技创新、产业合作等方面的深入交流。",
                time: "2024",
                from: "北京国商科创咨询有限公司",
                imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/6a5118ae77c2c40beada2dd9240839c.jpg",
                type: "news1",
                toUrl: "",
                contentList: [
                    {
                        index: "ar1-1",
                        content: "4月20日至7月25日，中国外商投资企业协会开发区工作委员会常务副会长张召堂陪同韩国成东集团董事长郑洪俊先生一行，对中国山东半岛、长三角和珠三角地区进行了一系列项目考察与对接活动。此次考察旨在探索合作机会，推动双方在科技创新、产业合作等方面的深入交流。\n" +
                            "\n" +
                            "   在山东，考察团访问了青岛、烟台、威海等各地的开发区。郑洪俊先生对青岛的创新环境和政策支持给予了高度评价，并对在各地开展合作项目表现出浓厚兴趣。双方讨论了在智能制造和环保技术领域的合作可能性，并初步达成了意向合作。\n" +
                            "\n" +
                            "  在长三角地区，考察团重点考察了上海、苏州、南通、宁波、舟山等地的沿海港口和开发区。详细了解了当地在产业升级和创新发展的成就。郑洪俊先生对长三角地区的高端制造业和科技创新环境赞赏有加，并与当地企业和政府部门进行了深入交流。双方就未来的合作方向，包括智能制造、绿色能源等领域，展开了广泛的探讨。\n" +
                            "\n" +
                            "  在珠三角地区，考察团访问了广州、惠州等城市的沿海及开发区。张召堂介绍了珠三角在高科技产业和现代服务业的最新发展情况。郑洪俊先生对珠三角的创新生态和产业集群表现出了浓厚的兴趣。双方就合作项目的具体细节进行了讨论，包括科技研发、人才培养和市场拓展等方面。\n" +
                            "\n" +
                            "  张召堂在总结讲话中表示，韩国成东集团与中国开发区的经济合作前景广阔。通过此次考察，双方不仅加深了对彼此市场的了解，也为未来的合作奠定了坚实的基础。他强调，希望通过进一步的交流与合作，能够实现双方的互利共赢，推动项目的顺利落地。\n" +
                            "\n" +
                            "  郑洪俊先生在考察结束时表示，感谢张召堂常务副会长及各地开发区的热情接待。他对未来的合作充满信心，并期待与中国开发区在多个领域展开深入合作，共同促进两国经济的繁荣与发展。",
                        imgUrl: "https://www.caefi.org.cn/",
                        type: "text"
                    },
                    {
                        index: "ar1-2",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/6a5118ae77c2c40beada2dd9240839c.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-3",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/11b359e4a72de51fd2f131289ee7d8e.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-4",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/fe0b3d007a7d35badf1d2173ec6850c.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-5",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/24233fed28de8dba88caa96af955d3c.jpg",
                        type: "img"
                    },
                ]
            },
            {
                id: "2",
                title: "开发区利用外资发展新质生产力座谈会在上海闵行开发区成功举办",
                content: "4月10日，开发区利用外资发展新质生产力座谈会在上海闵行开发区顺利举行。本次座谈会旨在探讨如何在新形势下更好地利用外资，推动开发区的新质生产力发展。中国外商投资企业协会副会长张召堂主持全天会议，常务副会长曹宏瑛发表了重要讲话。",
                time: "",
                from: "北京国商科创咨询有限公司",
                imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/aa4cf8dae7e0c8b7c206a0e99806ea7.jpg",
                type: "news1",
                toUrl: "",
                contentList: [
                    {
                        index: "ar2-1",
                        content: "   4月10日，开发区利用外资发展新质生产力座谈会在上海闵行开发区顺利举行。本次座谈会旨在探讨如何在新形势下更好地利用外资，推动开发区的新质生产力发展。中国外商投资企业协会副会长张召堂主持全天会议，常务副会长曹宏瑛发表了重要讲话。\n" +
                            "\n" +
                            "   在开幕致辞中，张召堂首先对与会嘉宾的到来表示热烈欢迎，并强调了此次座谈会的重要意义。他指出，外资作为推动开发区发展的重要力量，在新质生产力的提升中扮演着关键角色。张召堂表示，通过本次会议，开发区将进一步明确利用外资的方向，为新质生产力的培育提供更加有力的支持。\n" +
                            "\n" +
                            "  常务副会长曹宏瑛在讲话中深入分析了当前全球经济环境的变化及其对外资流动的影响。他指出，随着国际投资格局的调整，开发区需要更加注重吸引优质外资，推动科技创新和产业升级。曹宏瑛特别强调，新质生产力的发展是实现高质量发展的关键，开发区应积极借鉴国际经验，引导外资投入高端制造业、现代服务业和新兴产业，从而提升区域竞争力和可持续发展能力。\n" +
                            "\n" +
                            "  在一天的会议中，与会专家、学者和企业代表围绕外资利用与新质生产力的结合展开了深入讨论。大家分享了各自在吸引外资、创新驱动发展方面的经验与成果，并就如何进一步优化政策环境、促进外资与本地资源的有效结合提出了许多建设性意见。\n" +
                            "\n" +
                            "  张召堂在会议总结中表示，通过本次座谈会，各方达成了广泛共识，明确了开发区在利用外资推动新质生产力发展的具体路径。他强调，开发区要充分发挥自身优势，继续加强与外资企业的合作，不断创新模式，实现更高水平的开放与发展。\n" +
                            "\n" +
                            "   此次座谈会的成功举办，不仅为开发区利用外资推动新质生产力发展提供了新的思路，也为未来的合作奠定了坚实基础。与会者纷纷表示，将继续深化交流合作，共同推动开发区在新时代取得更大的成就。",
                        imgUrl: "https://www.caefi.org.cn/",
                        type: "text"
                    },
                    {
                        index: "ar2-2",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/aa4cf8dae7e0c8b7c206a0e99806ea7.jpg",
                        type: "img"
                    },
                    {
                        index: "ar2-3",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/ce2fcc88296d722543a445827911587.jpg",
                        type: "img"
                    },
                    {
                        index: "ar2-4",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/a9ba6387845009b453fcca584d92020.jpg",
                        type: "img"
                    }
                ]
            },
            {
                id: "3",
                title: "常务副会长张召堂带队考察广东惠州各开发区的营商环境与项目发展",
                content: "近日，中国外商投资企业协会开发区工作委员会常务副会长张召堂率领考察团到广东惠州，深入调研当地多个开发区的营商环境及重点项目进展情况。此次考察旨在进一步了解惠州各开发区的经济发展现状，为提升营商环境、推动高质量发展提出建设性建议。",
                time: "",
                from: "北京国商科创咨询有限公司",
                imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/f415f5048526aa91d370fc5b61f6082.jpg",
                type: "news1",
                toUrl: "",
                contentList: [
                    {
                        index: "ar1-1",
                        content: "   近日，中国外商投资企业协会开发区工作委员会常务副会长张召堂率领考察团到广东惠州，深入调研当地多个开发区的营商环境及重点项目进展情况。此次考察旨在进一步了解惠州各开发区的经济发展现状，为提升营商环境、推动高质量发展提出建设性建议。\n" +
                            "\n" +
                            "  考察期间，张召堂一行走访了惠州经济技术开发区、仲恺高新技术开发区和大亚湾经济技术开发区等地，详细了解了各开发区在招商引资、产业布局、政策支持等方面的情况。在企业座谈会上，张召堂与各开发区领导及企业代表进行了深入交流。他表示，惠州作为粤港澳大湾区的重要节点城市，开发区的高质量发展对区域经济的整体提升具有重要意义。惠州各开发区在营商环境的优化上已经取得了显著成效，尤其是在引进高新技术产业、提升服务水平、优化政务服务等方面，走在了全国前列。他强调，当前国际经济形势复杂多变，开发区要继续优化营商环境，提高服务效率，积极引导产业转型升级，吸引更多优质项目落户。\n" +
                            "\n" +
                            "   在项目考察过程中，张召堂对多个重点项目的进展情况给予了高度评价。他特别提到，大亚湾经济技术开发区在能源化工和先进制造业领域的布局具有示范效应，希望开发区能够继续发挥资源优势，推动项目早日达产达效，为地方经济注入新动力。\n" +
                            "\n" +
                            "  在总结发言中，张召堂强调，开发区的高质量发展不仅要依靠政策支持，更要依赖企业的创新和市场的驱动。惠州各开发区要充分发挥区域优势，进一步优化营商环境，提升服务水平，吸引更多具有竞争力的企业和项目落地，形成产业集群效应。他还表示，中国外商投资企业协会开发区工作委员会将继续关注并支持惠州的开发区发展，为区域经济的腾飞贡献力量。\n" +
                            "\n" +
                            "   此次考察活动不仅为惠州各开发区的营商环境建设带来了新的思路，也为进一步加强区域合作、推动产业升级奠定了基础。与会各方纷纷表示，将认真落实张召堂副会长的建议，积极推动惠州开发区的高质量发展。",
                        imgUrl: "https://www.caefi.org.cn/",
                        type: "text"
                    },
                    {
                        index: "ar1-2",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/f415f5048526aa91d370fc5b61f6082.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-3",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/2a8b58b05d4c9c8ef038ce04471418d.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-4",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/bb16a6b2c0aa5f9af71ca483d7dddaa.jpg",
                        type: "img"
                    }
                ]
            },
            {
                id: "4",
                title: "中国开发区兴办40周年对话交流会及签约仪式在仪陇举行，张召堂致辞",
                content: "7月5日，中国开发区兴办40周年对话交流会及签约仪式在四川仪陇隆重举行。此次活动汇聚了各界代表，共同庆祝中国开发区40年的辉煌成就，并探讨未来发展方向。中国外商投资企业协会常务副会长曹宏瑛主持会议，副会长张召堂出席活动并发表致辞。",
                time: "",
                from: "北京国商科创咨询有限公司",
                imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/cb0f9e985cb208313ec71206492ba4c.jpg",
                type: "news1",
                toUrl: "",
                contentList: [
                    {
                        index: "ar1-1",
                        content: "  7月5日，中国开发区兴办40周年对话交流会及签约仪式在四川仪陇隆重举行。此次活动汇聚了各界代表，共同庆祝中国开发区40年的辉煌成就，并探讨未来发展方向。中国外商投资企业协会常务副会长曹宏瑛主持会议，副会长张召堂出席活动并发表致辞。\n" +
                            "\n" +
                            "   在致辞中，张召堂回顾了中国开发区四十年的发展历程。他指出，四十年来，中国开发区从试点起步，逐渐发展成为推动国家经济发展的重要引擎，为中国的现代化建设作出了卓越贡献。张召堂强调，开发区不仅是吸引外资和技术创新的高地，更是深化改革开放、推动区域经济协调发展的重要载体。\n" +
                            "\n" +
                            "   张召堂表示，当前，全球经济格局正在发生深刻变化，中国开发区站在了新的历史起点上。未来，开发区要继续坚持创新驱动发展战略，着力推动产业转型升级，加强科技研发和高端人才的引进。他还强调，开发区的发展不仅要注重经济效益，更要践行绿色发展理念，实现可持续的高质量发展。\n" +
                            "\n" +
                            "   随后，在签约仪式上，多项战略合作协议成功签署，涉及科技创新、产业合作、人才培养等多个领域。张召堂表示，这些合作项目的落地，将为开发区未来的发展注入新的活力，也为推动区域经济高质量发展提供强有力的支撑。\n" +
                            "\n" +
                            "   对话交流环节中，张召堂与来自全国各地的开发区负责人、专家学者和企业代表进行了深入交流，探讨了开发区在新形势下的机遇与挑战。他鼓励各方加强合作，共同应对全球经济环境的变化，继续在改革开放的道路上勇敢前行。\n" +
                            "\n" +
                            "   此次活动的成功举办，标志着中国开发区在新时代迎来了新的发展机遇。签约的合作项目也将为开发区的创新发展带来更多的可能性。未来，中国开发区将继续发挥其独特优势，为国家经济的高质量发展作出更大贡献。",
                        imgUrl: "https://www.caefi.org.cn/",
                        type: "text"
                    },
                    {
                        index: "ar1-2",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/cb0f9e985cb208313ec71206492ba4c.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-3",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/7f1dca490841d6e776fbffd7d7e5590.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-4",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/787de8bdccb755922420660b7af9a23.jpg",
                        type: "img"
                    }
                ]
            },
            {
                id: "5",
                title: "中国开发区兴办40周年座谈会在广安举行，张召堂主持会议",
                content: "7月3日，中国开发区兴办40周年座谈会在四川广安隆重召开，会议由中国外商投资企业协会副会长张召堂主持。常务副会长曹宏瑛发表讲话，此次座谈会汇聚了来自全国各地的开发区领导、行业专家和企业代表，共同回顾中国开发区四十年来的辉煌成就，并展望未来发展的蓝图。",
                time: "",
                from: "北京国商科创咨询有限公司",
                imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/cb0f9e985cb208313ec71206492ba4c.jpg",
                type: "news1",
                toUrl: "",
                contentList: [
                    {
                        index: "ar1-1",
                        content: "   7月3日，中国开发区兴办40周年座谈会在四川广安隆重召开，会议由中国外商投资企业协会副会长张召堂主持。常务副会长曹宏瑛发表讲话，此次座谈会汇聚了来自全国各地的开发区领导、行业专家和企业代表，共同回顾中国开发区四十年来的辉煌成就，并展望未来发展的蓝图。\n" +
                            "\n" +
                            "   张召堂在开幕致辞中深情回顾了中国开发区四十年的发展历程。他指出，自1984年中国首批经济技术开发区设立以来，开发区始终站在改革开放的前沿，为推动国家经济发展、吸引外资、促进技术进步发挥了不可替代的作用。四十年的发展实践证明，开发区不仅是经济增长的引擎，更是改革创新的试验田，为中国经济的腾飞作出了巨大贡献。\n" +
                            "\n" +
                            "  在座谈会上，张召堂强调，当前世界经济形势复杂多变，开发区面临着新的挑战与机遇。要实现新时代的高质量发展，开发区必须继续深化改革，增强创新能力，推动产业转型升级。同时，他还指出，开发区的发展不仅要关注经济效益，更要注重生态环境的保护和社会责任的履行，力争在实现经济、社会、环境协调发展的道路上走在前列。\n" +
                            "\n" +
                            "   与会代表在座谈会上踊跃发言，分享了各自开发区在发展过程中取得的成功经验和面临的挑战。张召堂认真听取了大家的意见，并就大家关心的问题进行了详细的解答。他还特别强调，开发区之间要加强交流合作，互相学习，形成合力，共同推动全国开发区的高质量发展。\n" +
                            "\n" +
                            "   会议结束时，张召堂总结道，中国开发区四十年来的成功经验离不开党中央的坚强领导和各级政府的大力支持。未来，开发区要继续坚持改革开放不动摇，积极应对新形势下的发展挑战，为实现中华民族的伟大复兴作出新的更大贡献。\n" +
                            "\n" +
                            "  本次座谈会的成功举办，不仅为总结中国开发区四十年的发展成就提供了平台，也为未来的发展指明了方向。与会者纷纷表示，将认真落实会议精神，继续在各自的岗位上为开发区的创新发展贡献力量。",
                        imgUrl: "https://www.caefi.org.cn/",
                        type: "text"
                    },
                    {
                        index: "ar1-2",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/cb0f9e985cb208313ec71206492ba4c.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-3",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/981c35ac4c1f143d4f548359c2dc0a4.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-4",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/abe9d6949604ad64b37afd67026a1b3.jpg",
                        type: "img"
                    }
                ]
            },
            {
                id: "6",
                title: "张召堂在国家级大同开发区考察调研：助力高质量发展",
                content: "8月3日，中国外商投资企业协会开发区工作委员会常务副会长张召堂应邀来到国家级大同开发区，开展了一次以“高质量发展”为主题的考察调研活动。本次调研旨在深入了解大同开发区的经济发展现状，探讨如何推动区域经济实现更高质量的增长。",
                time: "",
                from: "北京国商科创咨询有限公司",
                imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/image.png",
                type: "news1",
                toUrl: "",
                contentList: [
                    {
                        index: "ar1-1",
                        content: "  8月3日，中国外商投资企业协会开发区工作委员会常务副会长张召堂应邀来到国家级大同开发区，开展了一次以“高质量发展”为主题的考察调研活动。本次调研旨在深入了解大同开发区的经济发展现状，探讨如何推动区域经济实现更高质量的增长。\n" +
                            "\n" +
                            "   调研期间，张召堂实地走访了开发区内的多家重点企业，详细了解了它们在技术创新、产品研发、市场开拓等方面的进展。他对企业在激烈的市场竞争中取得的成绩给予了充分肯定，同时也就如何进一步提高生产效率、加强科技创新等问题提出了建设性的建议。\n" +
                            "\n" +
                            "   在与开发区领导及企业家座谈时，张召堂强调，“美美与共，天下大同”是中华文化的重要理念，这一理念在当今的经济发展中同样具有深刻的现实意义。大同开发区作为国家级经济技术开发区，肩负着推动区域经济高质量发展的重要使命。要实现这一目标，开发区需要充分发挥自身的区位优势和产业基础，积极引进高端人才和先进技术，形成多方共赢的良好局面。\n" +
                            "\n" +
                            "   张召堂还指出，当前全球经济环境复杂多变，开发区的发展面临着新的挑战和机遇。要在这种形势下实现高质量发展，必须坚持创新驱动，注重绿色发展，构建现代化产业体系。同时，政府和企业要紧密合作，深化产学研合作，提升整体竞争力，为地方经济的持续繁荣注入强劲动力。\n" +
                            "\n" +
                            "   调研结束后，张召堂对大同开发区的发展前景表示乐观。他相信，在“美美与共，天下大同”的理念引领下，开发区将继续探索创新之路，实现经济、社会、生态的协调发展，为全国高质量发展树立标杆。\n" +
                            "\n" +
                            "   此次调研不仅为大同开发区的发展提供了新的思路，也进一步强化了协会与地方政府和企业的合作关系。参与调研的各方表示，将积极落实调研成果，推动开发区在新时代实现更大的突破。",
                        imgUrl: "https://www.caefi.org.cn/",
                        type: "text"
                    },
                    {
                        index: "ar1-2",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/image.png",
                        type: "img"
                    },
                    {
                        index: "ar1-3",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/image%20(1).png",
                        type: "img"
                    }
                ]
            },
            {
                id: "7",
                title: "副会长张召堂出席“印记北京中轴线——大众篆刻展览”启幕仪式",
                content: "7月19日，中国外商投资企业协会副会长张召堂应邀出席在北京世纪坛举行的“印记北京中轴线——大众篆刻展览”启幕仪式。此次展览旨在通过篆刻艺术，展现北京中轴线的历史文化底蕴，并进一步推动中轴线的文化遗产保护工作。",
                time: "",
                from: "中国外资协会",
                imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/3a950922824efa3bef34d74814d6e3b.jpg",
                type: "news1",
                toUrl: "",
                contentList: [
                    {
                        index: "ar1-1",
                        content: "   7月19日，中国外商投资企业协会副会长张召堂应邀出席在北京世纪坛举行的“印记北京中轴线——大众篆刻展览”启幕仪式。此次展览旨在通过篆刻艺术，展现北京中轴线的历史文化底蕴，并进一步推动中轴线的文化遗产保护工作。\n" +
                            "   北京中轴线是中国传统城市规划的杰出代表，是世界文化遗产的重要组成部分。此次展览将篆刻艺术与北京中轴线相结合，不仅创新了文化表达形式，也为大众更好地了解和保护中轴线提供了新的视角。能够让更多人感受到中轴线的独特魅力，增强保护意识。呼吁文化界、教育界和社会各界积极参与到中轴线保护的行动中来，共同守护这一珍贵的文化遗产。\n" +
                            "   此次展览汇集了众多篆刻艺术家的精品力作，每一件作品都蕴含着丰富的历史内涵和艺术情感。展览自启幕后，将持续至8月底，向公众开放，吸引了大量市民和游客前来参观。",
                        imgUrl: "https://www.caefi.org.cn/",
                        type: "text"
                    },
                    {
                        index: "ar1-2",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/3a950922824efa3bef34d74814d6e3b.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-3",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/e880cd6dfbd8ebae46a91ead225a5ed.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-4",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/c77a097c82ea2160115f266f12adf63.jpg",
                        type: "img"
                    }
                ]
            },
            {
                id: "8",
                title: "张召堂在国家级淄博高新区高新大讲堂讲授新质生产力与高新区高质量发展",
                content: "7月11日，中国外商投资企业协会开发区工作委员会常务副会长张召堂教授，应邀在国家级淄博高新区高新大讲堂发表了题为“新质生产力与高新区高质量发展”的主题讲座。此次讲座吸引了来自高新区管委会、企业界和科研机构的数百位代表到场聆听，共同探讨新形势下高新区发展的新路径。",
                time: "",
                from: "中国外资协会",
                imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/fc77fc167d13a3d5b1d659a3c7dcac4.jpg",
                type: "news1",
                toUrl: "",
                contentList: [
                    {
                        index: "ar1-1",
                        content: "   7月11日，中国外商投资企业协会开发区工作委员会常务副会长张召堂教授，应邀在国家级淄博高新区高新大讲堂发表了题为“新质生产力与高新区高质量发展”的主题讲座。此次讲座吸引了来自高新区管委会、企业界和科研机构的数百位代表到场聆听，共同探讨新形势下高新区发展的新路径。\n" +
                            "   张召堂教授从当前全球经济格局变化入手，深入剖析了新质生产力的内涵与作用。他指出，随着科技的快速进步，传统的生产力模式已经无法满足新时代的需求。新质生产力强调科技创新与人才培养的深度融合，是推动经济高质量发展的核心动力。张教授结合实际案例，阐述了高新区如何利用自身优势，在创新链与产业链的结合中寻求突破，打造新兴产业集群，进一步提升区域竞争力。\n" +
                            "   在讲座中，张召堂特别强调，高新区的发展不仅要依托先进的科技，更要注重营造良好的创新生态环境。他呼吁各方力量共同努力，为科研人员和企业提供更为宽松的政策支持和优质的服务保障，促进创新资源的高效配置。他还分享了国内外高新区在创新发展中的成功经验，提出淄博高新区应当立足本地实际，积极探索适合自身的发展模式。\n" +
                            "   此次讲座不仅为淄博高新区的发展提供了宝贵的思路，也进一步明确了高新区在新一轮经济转型中的使命和责任。张召堂教授的独到见解赢得了全场热烈的掌声。与会者纷纷表示，这次讲座使他们对高新区未来的发展充满信心，并期待在张教授的指导下，共同推动淄博高新区迈向新的高度。\n" +
                            "   通过此次高新大讲堂的学习交流，淄博高新区的各界人士进一步凝聚了共识，为下一步的高质量发展奠定了坚实的思想基础。",
                        imgUrl: "https://www.caefi.org.cn/",
                        type: "text"
                    },
                    {
                        index: "ar1-2",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/fc77fc167d13a3d5b1d659a3c7dcac4.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-3",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/7b6487685c6b53ac4a430eae8811c8e.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-4",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/8d46f9ed2968292e27e4afb596ed5e6.jpg",
                        type: "img"
                    },
                    {
                        index: "ar1-5",
                        content: "",
                        imgUrl: "https://article-1326545904.cos.ap-beijing.myqcloud.com/9db9304735f17d231e600f402228d9f.jpg",
                        type: "img"
                    }
                ]
            }
        ]
        return result.slice(0, num)
    },
    initMainPageMiddleCardList() {
        return [
            {
                id: "mc1",
                title: "品牌活动",
                content: "会长专题会（论坛）、外资365营商环境指数研究、外资企业展暨产业对接会、国际医药创新大会、绿色发展国际论坛等，宣传开放政策，反映企业呼声，促进营商环境改善，服务开放大局。",
                imgUrl: "zhongguo.png",
                style: "height:33px;width:33px;",
                textList: this.initArticleList(3)
            },
            {
                id: "mc2",
                title: "专业服务",
                content: "政策解读、展会论坛、业务培训、信息咨询、联谊活动等，积极宣传国家对外开放、吸引外资的法律、法规和政策。",
                imgUrl: "zhaobiaofangan.png",
                style: "height:30px;width:30px;",
                textList: this.initArticleList(3)
            },
            {
                id: "mc3",
                title: "公益行动",
                content: "引导会员企业积极履行企业社会责任，搭建专门平台，结合国家发展战略，积极宣传会员企业乡村振兴、环境保护、医疗健康、教育等领域的公益活动和民生项目。",
                imgUrl: "gongyi.png",
                style: "height:30px;width:34.78px;",
                textList: this.initArticleList(3)
            }
        ]
    },
    initMainPageBottomCardList() {
        return [
            {
                id: "bc1",
                title: "分支机构",
                content: "优质品牌保护委员会、药品研制和开发行业委员会、高质量发展分会等十多个分支机构，在不同领域开发专业服务。",
                imgUrl: "jigou.png",
                style: "height:30px;width:31.03px;",
                textList: this.initArticleList(3)
            },
            {
                id: "bc2",
                title: "各地协会",
                content: "与各地协会密切联系，形成合力，服务对外开放大局和积极吸收外资工作，促进地方经济健康发展。",
                imgUrl: "qiye.png",
                style: "height:40px;width:40px;",
                textList: this.initArticleList(3)
            }
        ]
    },
    initMainPageBottomSearchList() {
        return [
            {
                id: "bs1",
                title: "研究报告",
                imgUrl: "zhishichanquan_blue.png",
                hoverImgUrl: "zhishichanquan_white.png",
                style: "height:35px;width:35px;",
                hover: false
            },
            {
                id: "bs2",
                title: "社会责任报告",
                imgUrl: "baogaotixing_blue.png",
                hoverImgUrl: "baogaotixing_white.png",
                style: "height:45px;width:45px;",
                hover: false
            },
            {
                id: "bs3",
                title: "政策法规",
                imgUrl: "zhengcezhinan_blue.png",
                hoverImgUrl: "zhengcezhinan_white.png",
                style: "height:35px;width:35px;",
                hover: false
            },
            {
                id: "bs4",
                title: "政策解读",
                imgUrl: "zhaozhuanli_blue.png",
                hoverImgUrl: "zhaozhuanli_white.png",
                style: "height:35px;width:35px;",
                hover: false
            }
        ]
    },
    initNewsList() {
        return [
            {
                id: "t1",
                title: "重要新闻",
                type: "news1",
                textList: this.initArticleList(5)
            },
            {
                id: "t2",
                title: "通知通告",
                type: "news2",
                textList: []
            },
            {
                id: "t3",
                title: "重要活动",
                type: "news3",
                textList: []
            },
            {
                id: "t4",
                title: "品牌活动",
                type: "news4",
                textList: []
            },
            {
                id: "t5",
                title: "专业服务",
                type: "news5",
                textList: []
            },
            {
                id: "t6",
                title: "公益在行动",
                type: "news6",
                textList: []
            }
        ]
    },
    initInformationList() {
        return [
            {
                id: "t1",
                title: "研究报告",
                type: "information1",
                textList: this.initArticleList(4)
            },
            {
                id: "t2",
                title: "社会责任报告",
                type: "information2",
                textList: []
            },
            {
                id: "t3",
                title: "政策法规",
                type: "information3",
                textList: []
            },
            {
                id: "t4",
                title: "政策解读",
                type: "information4",
                textList: []
            },
            {
                id: "t5",
                title: "抗疫惠企政策",
                type: "information5",
                textList: []
            },
            {
                id: "t6",
                title: "第五次会员代表大会",
                type: "information6",
                textList: []
            },
            {
                id: "t7",
                title: "历史资料",
                type: "information7",
                textList: []
            }
        ]
    },
    initAboutList() {
        return [
            {
                id: "t1",
                title: "协会简介",
                type: "about1",
                textList: this.initArticleList(3)
            },
            {
                id: "t2",
                title: "协会领导",
                type: "about2",
                textList: []
            },
            {
                id: "t3",
                title: "协会章程",
                type: "about3",
                textList: []
            },
            {
                id: "t4",
                title: "大事记",
                type: "about4",
                textList: []
            }
        ]
    }
}